import { observable } from "mobx";

class Modal {
  @observable swipeModal: boolean = false;
  @observable swipeModalCurUrl: String = '';
}

export default Modal;
